import { InfoPageUnderlinedText } from './InfoPageUnderlinedText.style';

export default InfoPageUnderlinedText;
